import * as React from "react";
import BookIcon from "@mui/icons-material/Book";
import PeopleIcon from "@mui/icons-material/People";
import LabelIcon from "@mui/icons-material/Label";
import TerrainIcon from "@mui/icons-material/Terrain";
import SellIcon from "@mui/icons-material/Sell";
import HandymanIcon from "@mui/icons-material/Handyman";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import CropRotateIcon from "@mui/icons-material/CropRotate";
import ArticleIcon from "@mui/icons-material/Article";
import StyleIcon from "@mui/icons-material/Style";
import CategoryIcon from "@mui/icons-material/Category";
import CampaignIcon from "@mui/icons-material/Campaign";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import LayersIcon from '@mui/icons-material/Layers';
import NavigationIcon from "@mui/icons-material/Navigation";
import TuneIcon from '@mui/icons-material/Tune';
import GroupsIcon from '@mui/icons-material/Groups';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import SubMenu from "./SubMenu";
import HttpClient from "src/providers/HttpClient";
import ApiResources from "src/providers/ApiResources";
import { Box, Divider, Typography, useMediaQuery } from "@mui/material";
import { UserSection } from "./UserSection";
import { Menu } from "src/enterprise/ra-rbac";
import { useNotify } from 'react-admin';

export const MainMenu = () => {
  const [user, setUser] = React.useState<any>(null);
  const sidebarOpen: boolean =
    localStorage.getItem("RaStore.sidebar.open") ?
    localStorage.getItem("RaStore.sidebar.open") === "true" :
    true;
  const notify = useNotify();

  React.useEffect(() => {
    HttpClient(ApiResources.getLoggedUser(), {
      method: "GET",
    }).then(({ json }) => {
      setUser(json);
    }).catch(error => {
      notify(error.message, { type: 'error' });
    });
  }, []);

  return (
    <Menu sx={{
      '&.RaMenu-open a': {
        paddingLeft:'18px',
      },
      '&.RaMenu-open a div':{
          minWidth:'32px !important'
      },
      '&.RaMenu-closed div svg':{
          minWidth:'32px !important',
          marginRight:'10px'
      },
      '&.RaMenu-closed > div, a':{
        paddingLeft:'12px',
      },
      '&.RaMenu-closed .MuiList-root a':{
        paddingLeft:'0'
      }
    }}>
      {sidebarOpen && user && (
        <Box>
          <UserSection user={user} />
          <Divider
            sx={{
              borderColor: "#dfdfdf",
              my: 1,
            }}
          />
        </Box>
      )}
      
      <Menu.DashboardItem />
      <MenuLabel text={"Management"} sidebarOpen={sidebarOpen} />

      <SubMenu primaryText="CMS" leftIcon={<HandymanIcon />}>
        <Menu.Item
          
          to="/admin/pages"
          primaryText="Pages"
          resource="admin/pages"
          action="list"
          leftIcon={<BookIcon />}
        />
        <Menu.Item
          to="/admin/articles"
          primaryText="Articles"
          resource="admin/articles"
          action="list"
          leftIcon={<ArticleIcon />}
        />
        <Menu.Item
          to="/admin/article/tags"
          primaryText="Tags"
          resource="admin/article/tags"
          action="list"
          leftIcon={<StyleIcon />}
        />
        <Menu.Item
          to="/admin/article/categories"
          primaryText="Categories"
          resource="admin/article/categories"
          action="list"
          leftIcon={<CategoryIcon />}
        />
      </SubMenu>
      <SubMenu primaryText="Customers" leftIcon={<PeopleIcon />}>
        <Menu.Item
          to="/admin/users"
          primaryText="Customers"
          resource="admin/users"
          action="list"
          leftIcon={<PeopleIcon />}
        />
        <Menu.Item
          to="/admin/groups"
          primaryText="Groups"
          resource="admin/groups"
          action="list"
          leftIcon={<GroupsIcon />}
        />
      </SubMenu>
      <Menu.Item
        to="/admin/navigations"
        primaryText="Navigation"
        resource="admin/navigations"
        action="list"
        leftIcon={<NavigationIcon />}
      />
      
      <Menu.Item
        to="/admin/territories"
        primaryText="Territories"
        resource="admin/territories"
        action="list"
        leftIcon={<TerrainIcon />}
      />
      <Menu.Item
        to="/admin/promotions"
        primaryText="Promotions"
        resource="admin/promotions"
        action="list"
        leftIcon={<CampaignIcon />}
      />
      <Menu.Item
        to="/admin/faqs"
        primaryText="FAQ"
        resource="admin/faqs"
        action="list"
        leftIcon={<QuestionAnswerIcon />}
      />
      <SubMenu primaryText="Catalog" leftIcon={<AutoStoriesIcon />}>
        <Menu.Item
          to="/admin/products"
          primaryText="Products"
          resource="admin/products"
          action="list"
          leftIcon={<SellIcon />}
        />
        <Menu.Item
          to="/admin/product/attribute-sets"
          primaryText="Attribute Sets"
          resource="admin/product/attribute-sets"
          action="list"
          leftIcon={<SellIcon />}
        />
        <Menu.Item
          to="/admin/product/attributes"
          primaryText="Attributes"
          resource="admin/product/attributes"
          action="list"
          leftIcon={<SellIcon />}
        />
        <Menu.Item
          to="/admin/product/samples"
          primaryText="Samples"
          resource="admin/product/samples"
          action="list"
          leftIcon={<SellIcon />}
        />
        <Menu.Item
          to="admin/product/categories"
          primaryText="Product Categories"
          resource="admin/product/categories"
          action="list"
          leftIcon={<CategoryIcon />}
        />
      </SubMenu>
      <Menu.Item
        to="/admin/product/stock"
        primaryText="Stock"
        resource="admin/product/stock"
        action="list"
        leftIcon={<LayersIcon />}
      />
      <SubMenu primaryText="Makers" leftIcon={<HandymanIcon />}>
        <Menu.Item
          to="/admin/makers"
          primaryText="Makers"
          resource="admin/makers"
          action="list"
          leftIcon={<HandymanIcon />}
        />
        <Menu.Item
          to="/admin/maker/filters"
          primaryText="Filters"
          resource="admin/maker/filters"
          action="list"
          leftIcon={<FilterAltIcon />}
        />
      </SubMenu>
      <SubMenu primaryText="Importer" leftIcon={<CropRotateIcon />}>
        <Menu.Item
          to="/admin/importer/sheets"
          primaryText="Mapping"
          resource="admin/importer/sheets"
          action="list"
          leftIcon={<MoveUpIcon />}
        />
        <Menu.Item
          to="/admin/importer"
          primaryText="Process"
          resource="admin/importer"
          action="list"
          leftIcon={<CropRotateIcon />}
        />
      </SubMenu>
      <SubMenu primaryText="Subscribers" leftIcon={<AnnouncementIcon />}>
        <Menu.Item
          to="/admin/product/sample/subscribers"
          primaryText="Sample Subscribers"
          resource="admin/product/sample/subscribers"
          action="list"
          leftIcon={<MoveUpIcon />}
        />
        <Menu.Item
          to="/admin/product/subscribers"
          primaryText="Fabric Subscribers"
          resource="admin/product/subscribers"
          action="list"
          leftIcon={<MoveUpIcon />}
        />
        <Menu.Item
          to="/admin/newsletter/subscribers"
          primaryText="Newsletter Subscribers"
          resource="admin/newsletter/subscribers"
          action="list"
          leftIcon={<MoveUpIcon />}
        />
      </SubMenu>
      <SubMenu primaryText="Taxes" leftIcon={<LocalAtmIcon />}>
        <Menu.Item
          to="/admin/taxes"
          primaryText="Tax Classes"
          resource="admin/taxes"
          action="list"
          leftIcon={<LocalAtmIcon />}
        ></Menu.Item>
        <Menu.Item
          to="/admin/tax/items"
          primaryText="Tax Rates"
          resource="admin/tax/items"
          action="list"
          leftIcon={<LocalAtmIcon />}
        ></Menu.Item>
      </SubMenu>
      <SubMenu primaryText="Sales" leftIcon={<TrendingUpIcon />}>
        <Menu.Item
          to="/admin/orders"
          primaryText="Orders"
          resource="admin/orders"
          action="list"
          leftIcon={<ShoppingCartIcon />}
        ></Menu.Item>
      </SubMenu>
      <Menu.Item
        to="/admin/configurations"
        primaryText="Configuration"
        resource="admin/configurations"
        action="list"
        leftIcon={<TuneIcon />}
      />
      <MenuLabel text={"Reports"} sidebarOpen={false /*sidebarOpen*/} />
    </Menu>
  );
};

const MenuLabel = ({ text, sidebarOpen }) => {
  if (!sidebarOpen) return;

  return (
    <Typography
      color="text.secondary"
      variant="body1"
      sx={{ pl: 1.5, py: 0.75 }}
    >
      {text}
    </Typography>
  );
};
